<template>
<div>
  <div class="container">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>account_circle</md-icon>
        </div>
        <h4 class="title">{{isEdit ? $t('user.edit.title') : $t('user.create.title')}}</h4>
      </md-card-header>

      <md-card-content>
        <!-- FirstName -->
        <md-field :class="{'md-error': $v.userModel.firstName.$error && $v.userModel.firstName.$invalid, 'md-valid': !$v.userModel.firstName.$error && !$v.userModel.firstName.$invalid}">
          <label>{{$t('user.create.firstName')}}</label>
          <md-input v-model.trim="$v.userModel.firstName.$model"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.userModel.firstName.$error && $v.userModel.firstName.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.userModel.firstName.$error && !$v.userModel.firstName.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
        <!-- LastName -->
        <md-field :class="{'md-error': $v.userModel.lastName.$error && $v.userModel.lastName.$invalid, 'md-valid': !$v.userModel.lastName.$error && !$v.userModel.lastName.$invalid}">
          <label>{{$t('user.create.lastName')}}</label>
          <md-input v-model.trim="$v.userModel.lastName.$model"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.userModel.lastName.$error && $v.userModel.lastName.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.userModel.lastName.$error && !$v.userModel.lastName.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
        <!-- UserName -->
        <md-field :class="{'md-error': $v.userModel.userName.$error && $v.userModel.userName.$invalid, 'md-valid': !$v.userModel.userName.$error && !$v.userModel.userName.$invalid}">
          <label>{{$t('user.create.userName')}}</label>
          <md-input v-model.trim="$v.userModel.userName.$model"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.userModel.userName.$error && $v.userModel.userName.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.userModel.userName.$error && !$v.userModel.userName.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
        <!-- Email -->
        <md-field :class="{'md-error': $v.userModel.email.$error && $v.userModel.email.$invalid, 'md-valid': !$v.userModel.email.$error && !$v.userModel.email.$invalid}">
          <label>{{$t('user.create.email')}}</label>
          <md-input v-model.trim="$v.userModel.email.$model"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.userModel.email.$error && $v.userModel.email.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.userModel.email.$error && !$v.userModel.email.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
        <template v-if="!isEdit">
          <!-- Password -->
          <md-field :class="{'md-error': $v.userModel.password.$error && $v.userModel.password.$invalid, 'md-valid': !$v.userModel.password.$error && !$v.userModel.password.$invalid}">
            <label>{{$t('user.create.password')}}</label>
            <md-input type="password" v-model.trim="$v.userModel.password.$model"></md-input>
          </md-field>
          <!-- Repeat Password -->
          <md-field :class="{'md-error': $v.userModel.passwordConfirm.$error && $v.userModel.passwordConfirm.$invalid, 'md-valid': !$v.userModel.passwordConfirm.$error && !$v.userModel.passwordConfirm.$invalid}">
            <label>{{$t('user.create.repeatPassword')}}</label>
            <md-input type="password" v-model.trim="$v.userModel.passwordConfirm.$model"></md-input>
          </md-field>
        </template>
        <!-- Roles -->
        <div>
          <p>Roles</p>
          <md-checkbox v-model="userModel.roles" value="Admin">Admin</md-checkbox>
          <md-checkbox v-model="userModel.roles" value="ShowController">ShowController</md-checkbox>
        </div>

        <div class="actions">
          <md-button @click="isEdit ? userUpdate() : userCreate()" class="md-info">
            {{isEdit ? $t('user.edit.edit') : $t('user.create.create')}}
          </md-button>
          <md-button v-if="isEdit" @click="userDelete()" class="md-danger">
            {{$t('user.edit.delete')}}
          </md-button>
        </div>
      </md-card-content>
    </md-card>
  </div>
  <div class="container">
    <md-card v-if="isEdit">
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>account_circle</md-icon>
        </div>
        <h4 class="title">{{$t('user.edit.changePassword')}}</h4>
      </md-card-header>

      <md-card-content>
        <!-- Password -->
        <md-field :class="{'md-error': $v.changePasswordModel.oldPassword.$error && $v.changePasswordModel.oldPassword.$invalid, 'md-valid': !$v.changePasswordModel.oldPassword.$error && !$v.changePasswordModel.oldPassword.$invalid}">
          <label>{{$t('user.create.oldPassword')}}</label>
          <md-input type="password" v-model.trim="$v.changePasswordModel.oldPassword.$model"></md-input>
        </md-field>
        <!-- Repeat Password -->
        <md-field :class="{'md-error': $v.changePasswordModel.newPassword.$error && $v.changePasswordModel.newPassword.$invalid, 'md-valid': !$v.changePasswordModel.newPassword.$error && !$v.changePasswordModel.newPassword.$invalid}">
          <label>{{$t('user.create.newPassword')}}</label>
          <md-input type="password" v-model.trim="$v.changePasswordModel.newPassword.$model"></md-input>
        </md-field>
        <md-button @click="changePassword()" class="md-info">
          {{$t('user.edit.changePassword')}}
        </md-button>
      </md-card-content>
    </md-card>
  </div>
</div>
</template>

<script>
import { required, email, sameAs } from 'vuelidate/lib/validators';
import { SlideYDownTransition } from "vue2-transitions";
import { mapState } from 'vuex';

export default {
  components: {
    SlideYDownTransition
  },
  computed: {
    ...mapState({
      listUsers: state => state.SecurityModule.listUsers
    })
  },
  data () {
    return {
      isEdit: false,
      userModel: {
        firstName: "",
        lastName: "",
        userName: "",
        email: "",
        password: "",
        passwordConfirm: "",
        roles: []
      },
      changePasswordModel: {
        userId: Number(this.$route.params.id),
        oldPassword: "",
        newPassword: ""
      }
    }
  },
  async mounted() {
    if (this.$route.params.id != undefined) {
      this.isEdit = true
      if (this.listUsers.length == 0) {
        await this.$store.dispatch('usersGet')
      }
      this.userModel = this.listUsers.find(user => user.id == this.$route.params.id)
    }
  },
  methods: {
    async userCreate() {
      this.$v.userModel.$touch()
      if (!this.$v.userModel.$invalid) {
        const response = await this.$store.dispatch('userCreate', this.userModel)
        if (response != undefined) {
          this.$notify({
            message: this.$t(`notifications.user.create`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
          this.$router.push("/list/users")
        } else {
          this.$store.dispatch("openModalError")
        }
      }
    },
    async userUpdate() {
      this.$v.userModel.$touch()
      if (!this.$v.userModel.$invalid) {
        const response = await this.$store.dispatch('userUpdate', this.userModel)
        if (response != undefined) {
          this.$notify({
            message: this.$t(`notifications.user.update`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
          this.$router.push("/list/users")
        } else {
          this.$store.dispatch("openModalError")
        }
      }
    },
    async changePassword() {
      this.$v.changePasswordModel.$touch()
      if (!this.$v.changePasswordModel.$invalid) {
        const response = await this.$store.dispatch('changePass', this.changePasswordModel)
        if (response != undefined) {
          this.$notify({
            message: this.$t(`notifications.user.changePassword`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
          this.$router.push("/list/users")  
        } else {
          this.$store.dispatch("openModalError")
        }
      }
    },
    async userDelete() {
      const response = await this.$store.dispatch('userDelete', {userId: Number(this.$route.params.id)})
      if (response != undefined) {
        this.$notify({
          message: this.$t(`notifications.user.delete`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.$router.push("/list/users")  
      } else {
        this.$store.dispatch("openModalError")
      }
    }
  },
  validations () {
    if (this.isEdit) {
      return {
        userModel: {
          firstName: {
            required
          },
          lastName: {
            required
          },
          userName: {
            required
          },
          email: {
            required,
            email
          },
          password: {},
          passwordConfirm: {}
        },
        changePasswordModel: {
          oldPassword: {
            required
          },
          newPassword: {
            required
          }
        }
      }
    } else {
      return {
        userModel: {
          firstName: {
            required
          },
          lastName: {
            required
          },
          userName: {
            required
          },
          email: {
            required,
            email
          },
          password: {
            required
          },
          passwordConfirm: {
            required,
            sameAsPassword: sameAs("password")
          }
        } 
      } 
    }
  },
  watch: {
    $route(to, from) {
      this.$router.go()
    }
  }
}
</script>
<style scoped>
p {
  margin-bottom: 0;
}
.actions {
  display: flex;
  justify-content: space-between;
}
</style>

